import { render, staticRenderFns } from "./casestudy_loop.vue?vue&type=template&id=624a57fc&scoped=true"
import script from "./casestudy_loop.vue?vue&type=script&lang=js"
export * from "./casestudy_loop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a57fc",
  null
  
)

export default component.exports